import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon, Progress } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";

import { importConcilieantionRatio } from "../redux/actions/dashboard";
import { GetConciliationRatio } from "../graphql/dashboard";
import { progressTierClassName } from "../utils/reconciliationProgress";
import { HMRModal } from "./HistoricalMonthlyReconciliations/HMRModal";

export const useConciliationRatio = () => {
  const dispatch = useDispatch();

  const { selectedCompany } = useSelector((state) => state.companyList);
  const { conciliationRatio } = useSelector((state) => state.dashboard);
  const updateTransactions = useSelector((state) => state.conciliacion.updateTransactions);
  const [variables, setVariables] = useState({
    companyId: selectedCompany?.id,
    month: new Date(),
  });
  const { fetching, data, reExecuteQuery } = GetConciliationRatio(
    variables.companyId,
    variables.month
  );

  useEffect(() => {
    setVariables({
      companyId: selectedCompany?.id,
      month: new Date(),
    });
  }, [selectedCompany?.id, conciliationRatio?.update, updateTransactions]);

  useEffect(() => {
    if (!reExecuteQuery) return;
    if (conciliationRatio?.update || updateTransactions) {
      reExecuteQuery({ requestPolicy: "network-only" });
    }
  }, [conciliationRatio?.update, updateTransactions, variables.companyId, reExecuteQuery]);

  useEffect(() => {
    if (!fetching && data) {
      dispatch(importConcilieantionRatio(data.getMonthlyMatchsRatio * 100));
    }
  }, [fetching, data, dispatch]);

  const ratioPct = Math.min(
    100,
    Math.max(0, Number(conciliationRatio?.ratio) || 0)
  );

  return { ratioPct, fetching };
};

export const ConciliationRatio = () => {
  const { t } = useTranslation("header");
  const { ratioPct } = useConciliationRatio();
  const [openHRMModal, setOpenHRMModal] = useState(false);

  const onClickConciliatorBarDiv = (e) => {
    e.preventDefault();
    setOpenHRMModal(true);
  };

  return (
    <div className="conciliationBarWrapper" onClick={onClickConciliatorBarDiv}>
      <div className="conciliationBar">
        <div className="conciliationBar__top">
          <div className="conciliationBar__title">
            <span>
              {t("reconciliation.reconciledThisMonth", {
                percent: parseFloat(ratioPct || 0).toFixed(1),
              })}
            </span>
          </div>
          <div className="conciliationBar__detail">
            {t("reconciliation.viewDetail")}
            <Icon name="angle right" />
          </div>
        </div>
        <Progress
          className={progressTierClassName(ratioPct)}
          percent={ratioPct}
        />
      </div>

      <HMRModal
        open={openHRMModal}
        setOpen={setOpenHRMModal}
      />

    </div>
  );
};
